export default "__VITE_ASSET__0e7e74e9__"